import { userDataRequest } from '../../lib/userDataRequest';

export const exportFeatures = (featureIds, fileType) => {
  /*
    #TODO: This can be refactored to just "export" to also be
    used for exporting collections as well.
    -- WD - July 12, 2021
  */
  let body = {};

  if (featureIds && featureIds.length) {
    body = {
      type: fileType,
      featureIds
    };
  } else {
    body = {
      type: fileType
    };
  }

  return userDataRequest('post', '/exports', {}, false, body);
};

export const getExportDetails = (exportId) => {
  return userDataRequest('get', `/exports/${exportId}`);
};
